import { Col, Row, Modal, Form, Switch, message, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Title from "../UI/Title/Title";
import { editPackaging, getItemsById } from "../../api/itemapi";
import { ItemsType } from "./itemsType";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { Dispatch, useEffect, useState } from "react";
import { AxiosResponse } from "axios";

type propsType = {
  openPackaging: boolean;
  setOpenPackaging: React.Dispatch<React.SetStateAction<boolean>>;
  id: any;
  isPacking?: boolean;
  ItemsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
      isChild: boolean;
    },
    unknown
  >;
  filter: boolean | undefined;
  search: any;
  setPaginatedItems: Dispatch<any>;
  loadingcategory: boolean;
  formatedcategory: {}[] | undefined;
  formatedItemUnit: {}[] | undefined;
  loadingItemUnit: boolean;
  formatedBrand: {}[] | undefined;
  loadingBrand: boolean;
  formatedSupplier: {}[] | undefined;
  loadingSupplier: boolean;
  formatedPriceScheme: {}[] | undefined;
  loadingPriceScheme: boolean;
  page: number;
};
export const PackagingModal = ({
  openPackaging,
  setOpenPackaging,
  id,
  isPacking,
  ItemsMutation,
  search,
  filter,
  setPaginatedItems,
  loadingcategory,
  formatedcategory,
  formatedItemUnit,
  loadingItemUnit,
  formatedBrand,
  loadingBrand,
  formatedSupplier,
  loadingSupplier,
  formatedPriceScheme,
  loadingPriceScheme,
  page,
}: propsType) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [, setError] = useState("");
  const [isPackingSwitch, setIsPackingSwitch] = useState(isPacking);

  const getItemsMutation = useMutation("getItems", getItemsById);
  function fillItemById(id: any, key: string) {
    getItemsMutation.mutateAsync(id).then((res) => {
      navigate(`/item/${id}`, {
        state: {
          item: res.data,
          formatedcategory: formatedcategory,
          loadingcategory: loadingcategory,
          formatedBrand: formatedBrand,
          loadingBrand: loadingBrand,
          formatedItemUnit: formatedItemUnit,
          loadingItemUnit: loadingItemUnit,
          formatedPriceScheme: formatedPriceScheme,
          loadingPriceScheme: loadingPriceScheme,
          formatedSupplier: formatedSupplier,
          loadingSupplier: loadingSupplier,
          key: key,
        },
      });
    });
  }

  const { mutate: mutateEdit, isLoading: isSaving } = useMutation(
    "editBrand",
    (packaging: ItemsType) => editPackaging(id, packaging),
    {
      onSuccess: (res) => {
        message.success("Saved successfully!");
        ItemsMutation({
          q: search,
          isActive: filter,
          limit: page * 10 + 10,
          isChild: false,
        }).then((res: any) => {
          setPaginatedItems(res.data?.data);
        });
        setOpenPackaging(false);
        if (isPackingSwitch) {
          fillItemById(id, "4");
        }
        setShouldRefresh(true);
      },
      onError: (error: any, context: unknown) => {
        if (setError) {
          setError(error.response.data.message);
          message.error(error.response.data.message);
        } else {
          message.error("");
        }
      },
    }
  );

  const [shouldRefresh, setShouldRefresh] = useState(false);
  const handleFinish = () => {
    const newPacking = form.getFieldsValue();
    for (const key in newPacking) {
      if (newPacking[key] === undefined) {
        if (key === "isPacking") {
          newPacking[key] = isPackingSwitch;
        } else {
          newPacking[key] = null;
        }
      }
    }
    // Check if the select value has changed
    if (newPacking.isPacking !== isPacking) {
      mutateEdit(newPacking);
    } else {
      // Handle the case when no changes were made
      setOpenPackaging(false);
      if (isPackingSwitch) {
        fillItemById(id, "4");
      }
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      isPacking: isPacking,
    });
  }, [isPacking, form, shouldRefresh]);
  useEffect(() => {
    if (shouldRefresh) {
      setShouldRefresh(false);
    }
  }, [shouldRefresh]);
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={400}
        onCancel={() => setOpenPackaging(false)}
        open={openPackaging}
        footer={[
          <Button
            key="cancel-button"
            onClick={() => setOpenPackaging(false)}
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              marginInlineEnd: "auto",
              height: "40px",
              width: "100px",
            }}
          >
            {`${t("cancel")}`}
          </Button>,
          <Button
            key="confirm-button"
            form="PackagingForm"
            htmlType="submit"
            style={{
              background: "#1677FF",
              color: "#fff",
              width: "100px",
              height: "40px",
              border: "none",
            }}
            disabled={isSaving}
          >
            {isSaving ? `${t("loading")}` : `${t("save")}`}
          </Button>,
        ]}
      >
        <Form
          onFinish={handleFinish}
          data-testid="form"
          layout="vertical"
          form={form}
          id="PackagingForm"
        >
          <Row>
            <Col>
              <Title title={`${t("item-packaging")}`} />
              {`${t("are-you-sure-you-want-to-edit-packaging-?")}`}

              <Col style={{ marginTop: "10px" }}>
                <Form.Item
                  label={t("packaging")}
                  name="isPacking"
                  valuePropName="checked"
                >
                  <Switch
                    onChange={(checked) => {
                      setIsPackingSwitch(checked);
                    }}
                    checkedChildren={t("yes")}
                    unCheckedChildren={t("no")}
                  />
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
